// import { useEffect, useState } from "react"
// import {  AiOutlineShoppingCart } from "react-icons/ai"
// import { BsChevronDown } from "react-icons/bs"
// import { useSelector } from "react-redux"
// import { Link, matchPath, useLocation } from "react-router-dom"
// import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
// import logo from "../../assets/Logo/logo1.png"
// import { NavbarLinks } from "../../data/navbar-links"
// import { apiConnector } from "../../services/apiConnector"
// import { categories } from "../../services/apis"
// import { ACCOUNT_TYPE } from "../../utils/constants"
// import ProfileDropdown from "../core/Auth/ProfileDropdown"



// function Navbar() {
//   const { token } = useSelector((state) => state.auth)
//   const { user } = useSelector((state) => state.profile)
//   const { totalItems } = useSelector((state) => state.cart)
//   const location = useLocation()

//   const [subLinks, setSubLinks] = useState([])
//   const [loading, setLoading] = useState(false)
//   const [isMenuOpen, setIsMenuOpen] = useState(false);

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   useEffect(() => {
//     ;(async () => {
//       setLoading(true)
//       try {
//         const res = await apiConnector("GET", categories.CATEGORIES_API)
//         setSubLinks(res.data.data)
//        console.log(res.data.data)
//       } catch (error) {
//         console.log("Could not fetch Categories.", error)
//       }
//       setLoading(false)
//     })()
//   }, [])

 
//   // console.log("sub links", subLinks)

//   const matchRoute = (route) => {
//     return matchPath({ path: route }, location.pathname)
//   }

//   return (
//     <div
//       className={`flex h-14 items-center justify-center  ${
//         location.pathname !== "/" ? "bg-pure-greys-400" : "bg-pure-greys-400"
//       } transition-all duration-200`}
//     >
//       <div className="flex w-11/12 max-w-maxContent items-center justify-between">
//         {/* Logo */}
//         <Link to="/">
//           <img src={logo} alt="Logo" width={150} height={40} loading="lazy" className=" "  />
//         </Link>
//         {/* Navigation links */}

        
//         <nav className="hidden md:block">
//           <ul className="flex gap-x-6 text-richblack-25">
//             {NavbarLinks.map((link, index) => (
//               <li key={index}>
//                 {link.title === "Catalog" ? (
//                   <>
//                     <div
//                       className={`group relative flex cursor-pointer items-center gap-1 ${
//                         matchRoute("/catalog/:catalogName")
//                           ? "text-blue-50"
//                           : "text-richblack-25"
//                       }`}
//                     >
//                       <p>{link.title}</p>
//                       <BsChevronDown />
//                       <div className="invisible absolute left-[50%] top-[50%] z-[1000] flex w-[200px] translate-x-[-50%] translate-y-[3em] flex-col rounded-lg bg-richblack-5 p-4 text-richblack-900 opacity-0 transition-all duration-150 group-hover:visible group-hover:translate-y-[1.65em] group-hover:opacity-100 lg:w-[300px]">
//                         <div className="absolute left-[50%] top-0 -z-10 h-6 w-6 translate-x-[80%] translate-y-[-40%] rotate-45 select-none rounded bg-richblack-5"></div>
//                         {loading ? (
//                           <p className="text-center">Loading...</p>
//                         ) : subLinks.length ? (
//                           <>
//                             {subLinks
//                               ?.filter(
//                                 (subLink) => subLink?.courses?.length >= 0
//                               )
//                               ?.map((subLink, i) => (
//                                 <Link
//                                   to={`/catalog/${subLink.name
//                                     .split(" ")
//                                     .join("-")
//                                     .toLowerCase()}`}
//                                   className="rounded-lg bg-transparent py-4 pl-4 hover:bg-richblack-50"
//                                   key={i}
//                                 >
                                
                                
//                                   <p className="text-center">{subLink.name}</p>
//                                 </Link>
//                               ))}
//                           </>
//                         ) : (
//                           <p className="text-center">No Courses Found</p>
//                         )}
//                       </div>
//                     </div>
//                   </>
//                 ) : (
//                   <Link to={link?.path}>
//                     <p
//                       className={`${
//                         matchRoute(link?.path)
//                           ? "text-blue-50"
//                           : "text-richblack-25"
//                       }`}
//                     >
//                       {link.title}
//                     </p>
//                   </Link>
//                 )}
//               </li>
//             ))}
//           </ul>
//         </nav>
//         {/* Login / Signup/Dashboard */}
//         <div className="hidden items-center gap-x-4 md:flex">
//           {user && user?.accountType !== ACCOUNT_TYPE.INSTRUCTOR && (
//             <Link to="/dashboard/cart" className="relative">
//               <AiOutlineShoppingCart className="text-2xl text-richblack-100" />
//               {totalItems > 0 && (
//                 <span className="absolute -bottom-2 -right-2 grid h-5 w-5 place-items-center overflow-hidden rounded-full bg-richblack-600 text-center text-xs font-bold text-yellow-100">
//                   {totalItems}
//                 </span>
//               )}
//             </Link>
//           )}
//           {token === null && (
//             <Link to="/login">
//               <button className="rounded-[8px] border border-richblack-900 bg-pure-greys-100 px-[12px] py-[8px] text-richblack-600 hover:bg-blue-200">
//                 Log in
//               </button>
//             </Link>
//           )}
//           {token === null && (
//             <Link to="/signup">
//               <button className="rounded-[8px] border border-richblack-900 bg-pure-greys-100 px-[12px] py-[8px] text-richblack-600 hover:bg-blue-200">
//                 Sign up
//               </button>
//             </Link>
//           )}
//           {token !== null && <ProfileDropdown />}
//         </div>
//         <button className="mr-4 md:hidden"  onClick={toggleMenu} >
//         {isMenuOpen ? <AiOutlineClose fontSize={24} /> : <AiOutlineMenu fontSize={24} />}
//         </button>
//       </div>
//     </div>
//   )
// }

// export default Navbar






// import { useEffect, useState } from "react";
// import { AiOutlineShoppingCart, AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
// import { BsChevronDown } from "react-icons/bs";
// import { useSelector } from "react-redux";
// import { Link, matchPath, useLocation } from "react-router-dom";
// import logo from "../../assets/Logo/logo1.png";
// import { NavbarLinks } from "../../data/navbar-links";
// import { apiConnector } from "../../services/apiConnector";
// import { categories } from "../../services/apis";
// import { ACCOUNT_TYPE } from "../../utils/constants";
// import ProfileDropdown from "../core/Auth/ProfileDropdown";
// import { HiSearch } from 'react-icons/hi'
// import { useNavigate } from 'react-router'
// function Navbar() {
//   const { token } = useSelector((state) => state.auth);
//   const { user } = useSelector((state) => state.profile);
//   const { totalItems } = useSelector((state) => state.cart);
//   const location = useLocation();
//   const [searchValue, setSearchValue] = useState("")
//   const [subLinks, setSubLinks] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//  const navigate = useNavigate();
//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   useEffect(() => {
//     (async () => {
//       setLoading(true);
//       try {
//         const res = await apiConnector("GET", categories.CATEGORIES_API);
//         setSubLinks(res.data.data);
//         console.log(res.data.data);
//       } catch (error) {
//         console.log("Could not fetch Categories.", error);
//       }
//       setLoading(false);
//     })();
//   }, []);

//   const matchRoute = (route) => {
//     return matchPath({ path: route }, location.pathname);
//   };
//   const handelSearch = (e) => {
//     e.preventDefault();
//     if (searchValue?.length > 0) {
//         // navigate(`/search/${searchValue}`);
//         navigate(`/search/${searchValue.toLowerCase()}`);
      
//         setSearchValue("");
       
//     }
// }
//   return (
//     <div   className={`flex h-14 items-center justify-center  ${
//       location.pathname !== "/" ? "bg-pure-greys-400" : "bg-pure-greys-400"
//     } transition-all duration-200`}>
//       <div className="w-11/12 max-w-maxContent mx-auto">
//         <div className="flex items-center justify-between h-14">
//           {/* Logo */}
//           <Link to="/">
//             <img src={logo} alt="Logo" width={150} height={40} loading="lazy" />
//           </Link>

//           {/* Desktop Navigation Links */}
//           <nav className="hidden md:flex  ">
//             <ul className="flex gap-x-6 text-richblack-25 font-semibold">
//               {NavbarLinks.map((link, index) => (

//                 <li key={index}>
                        
//                   {link.title === "Catalog" ? (
//                     <div className={`group relative flex cursor-pointer items-center gap-1 ${matchRoute("/catalog/:catalogName") ? "text-blue-50" : "text-richblack-25"}`}>
//                       <p>{link.title}</p>
//                       <BsChevronDown />
//                       <div className="invisible absolute left-1/2 top-full z-10 w-[200px] transform -translate-x-1/2 mt-2 p-4 bg-richblack-5 text-richblack-900 font-semibold rounded-lg opacity-0 transition-all duration-150 group-hover:visible group-hover:opacity-100 lg:w-[300px]">
//                         <div className="absolute left-1/2 top-0 h-6 w-6 bg-richblack-5 transform -translate-x-1/2 -translate-y-1/2 rotate-45"></div>
//                         {loading ? (
//                           <p className="text-center">Loading...</p>
//                         ) : subLinks.length ? (
//                           subLinks.filter(subLink => subLink?.courses?.length > 0).map((subLink, i) => (
//                             <Link to={`/catalog/${subLink.name.split(" ").join("-").toLowerCase()}`} className=" block px-4 py-2 hover:bg-blue-50 rounded-lg" key={i}>
//                               <p>{subLink.name}</p>
//                             </Link>
//                           ))
//                         ) : (
//                           <p className="text-center">No Courses Found</p>
//                         )}
//                       </div>
//                     </div>
//                   ) : (
//                     <Link to={link?.path}>
//                       <p className={`${matchRoute(link?.path) ? "text-blue-50" : "text-richblack-25"}`}>{link.title}</p>
//                     </Link>
//                   )}
//                 </li>
//               ))}
//    <form onSubmit={handelSearch} className='flex items-center relative lg:mx-16 '>
//                             <input value={searchValue} onChange={(e) => { setSearchValue(e.target.value) }} id='searchinput' type="text" placeholder="Search" className=' absolute top-0 left-0 border-0 focus:ring-1 ring-richblack-400 rounded-full px-2 py-1 text-[15px] w-28 text-richblack-600 focus:outline-none focus:border-transparent bg-white' />
//                             <HiSearch type='submit' id='searchicon' size={20} className="  text-richblack-400 top-1 absolute cursor-pointer left-20" />
//                         </form>
                  
//             </ul>
//           </nav>

//           {/* User Controls */}
//           <div className="hidden md:flex items-center gap-x-4">
//             {user && user?.accountType !== ACCOUNT_TYPE.INSTRUCTOR && (
//               <Link to="/dashboard/cart" className="relative">
//                 <AiOutlineShoppingCart className="text-2xl text-richblack-100" />
//                 {totalItems > 0 && (
//                   <span className="absolute -bottom-2 -right-2 grid h-5 w-5 place-items-center rounded-full bg-richblack-600 text-xs font-bold text-yellow-100">
//                     {totalItems}
//                   </span>
//                 )}
//               </Link>
//             )}
//             {token === null ? (
//               <>
//                 <Link to="/login">
//                   <button className="rounded-lg border border-richblack-900 bg-pure-greys-100 px-3 py-2 text-richblack-600 hover:bg-blue-200">Log in</button>
//                 </Link>
//                 <Link to="/signup">
//                   <button className="rounded-lg border border-richblack-900 bg-pure-greys-100 px-3 py-2 text-richblack-600 hover:bg-blue-200">Sign up</button>
//                 </Link>
//               </>
//             ) : (
//               <ProfileDropdown />
//             )}
//           </div>

//           {/* Mobile Menu Button */}
//           <button className="md:hidden" onClick={toggleMenu}>
//             {isMenuOpen ? <div /> : <AiOutlineMenu fontSize={24} />}
//           </button>
//         </div>
//       </div>

//       {/* Mobile Menu */}
//       <div className={`fixed w-full top-0 z-40 bg-pure-greys-900 bg-opacity-75 transform ${isMenuOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 md:hidden`}>
//         <div className="flex flex-col items-start p-4 space-y-4">
//           <button className="self-end" onClick={toggleMenu}>
//             <AiOutlineClose fontSize={24} />
//           </button>
//           {NavbarLinks.map((link, index) => (
//             <div key={index} className="w-[200px]  ">
//               {link.title === "Catalog" ? (
//                 <div className="group relative ">
//                   <div className="flex items-center justify-between cursor-pointer text-white hover:text-blue-50" onClick={toggleMenu}>
//                     <span>{link.title}</span>
//                     <BsChevronDown />
//                   </div>
//                   <div className=" rounded-xl mt-2 ml-2 pl-2 border border-pure-greys-100 bg-richblack-5 text-richblack-900">
//                     {loading ? (
//                       <p className="text-white">Loading...</p>
//                     ) : subLinks.length ? (
//                       subLinks.filter(subLink => subLink?.courses?.length > 0).map((subLink, i) => (
//                         <Link to={`/catalog/${subLink.name.split(" ").join("-").toLowerCase()}`} className="block px-4 py-2 text-richblack-900 hover:text-blue-50 " key={i} onClick={() => setIsMenuOpen(false)}>
//                           {subLink.name}
//                         </Link>
//                       ))
//                     ) : (
//                       <p className="text-white">No Courses Found</p>
//                     )}
//                   </div>
//                 </div>
//               ) : (
//                 <Link to={link.path} className="text-white hover:text-gray-400" onClick={() => setIsMenuOpen(false)}>
//                   {link.title}
//                 </Link>
//               )}
//             </div>
//           ))}
//           <div className="flex flex-col space-y-4 mt-4 w-full">
//             {user && user?.accountType !== ACCOUNT_TYPE.INSTRUCTOR && (
//               <Link to="/dashboard/cart" className="relative">
//                 <AiOutlineShoppingCart className="text-2xl text-white" />
//                 {totalItems > 0 && (
//                   <span className="absolute -bottom-2 -right-2 grid h-5 w-5 place-items-center rounded-full bg-richblack-600 text-xs font-bold text-yellow-100">
//                     {totalItems}
//                   </span>
//                 )}
//               </Link>
//             )}
//             {token === null ? (
//               <>
//                <div className="space-x-4 flex flex-row">
//                 <Link to="/login">
//                   <button className=" rounded-lg border border-richblack-900 bg-pure-greys-100 px-3 py-2 text-richblack-600 hover:bg-blue-200">Log in</button>
//                 </Link>
//                 <Link to="/signup">
//                   <button className="rounded-lg border border-richblack-900 bg-pure-greys-100 px-3 py-2 text-richblack-600 hover:bg-blue-200">Sign up</button>
//                 </Link>
//                   <form onSubmit={handelSearch} className='flex items-center relative '>
//                             <input value={searchValue} onChange={(e) => { setSearchValue(e.target.value) }} id='searchinput' type="text" placeholder="Search" className=' absolute top-0 left-0 border-0 focus:ring-1 ring-richblack-400 rounded-full px-2 py-2 text-[15px] w-28 text-richblack-600 focus:outline-none focus:border-transparent bg-white' />
//                             <HiSearch type='submit' id='searchicon' size={20} className="  text-richblack-600 top-2 absolute cursor-pointer left-20" />
//                         </form>
//                 </div>
//               </>
//             ) : (
//               <ProfileDropdown />
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Navbar;




import { useEffect, useState } from "react";
import { AiOutlineShoppingCart, AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import { BsChevronDown } from "react-icons/bs";
import { useSelector } from "react-redux";
import { Link, matchPath, useLocation } from "react-router-dom";
import logo from "../../assets/Logo/logo1.png";
import { NavbarLinks } from "../../data/navbar-links";
import { apiConnector } from "../../services/apiConnector";
import { categories, notes } from "../../services/apis";  // Import your Notes API
import { ACCOUNT_TYPE } from "../../utils/constants";
import ProfileDropdown from "../core/Auth/ProfileDropdown";
import { HiSearch } from 'react-icons/hi'
import { useNavigate } from 'react-router'

function Navbar() {
  const { token } = useSelector((state) => state.auth);
  const { user } = useSelector((state) => state.profile);
  const { totalItems } = useSelector((state) => state.cart);
  const location = useLocation();
  const [searchValue, setSearchValue] = useState("");
  const [subLinks, setSubLinks] = useState([]);
  const [notesLinks, setNotesLinks] = useState([]); // State to hold notes data
  const [loading, setLoading] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    // Fetch Categories
    (async () => {
      setLoading(true);
      try {
        const res = await apiConnector("GET", categories.CATEGORIES_API);
        setSubLinks(res.data.data);
        console.log(res.data.data);
      } catch (error) {
        console.log("Could not fetch Categories.", error);
      }
      setLoading(false);
    })();

    // Fetch Notes
    (async () => {
      setLoading(true);
      try {
        const res = await apiConnector("GET", categories.NOTES_CATEGORIES_API);  // Replace with your Notes API
        setNotesLinks(res.data.data);
        console.log(res.data.data);
      } catch (error) {
        console.log("Could not fetch Notes.", error);
      }
      setLoading(false);
    })();
  }, []);

  const matchRoute = (route) => {
    return matchPath({ path: route }, location.pathname);
  };

  const handelSearch = (e) => {
    e.preventDefault();
    if (searchValue?.length > 0) {
      navigate(`/search/${searchValue.toLowerCase()}`);
      setSearchValue("");
    }
  };

  return (
    <div className={`flex h-14 items-center justify-center ${location.pathname !== "/" ? "bg-pure-greys-400" : "bg-pure-greys-400"} transition-all duration-200`}>
      <div className="w-11/12 max-w-maxContent mx-auto">
        <div className="flex items-center justify-between h-14">
          {/* Logo */}
          <Link to="/">
            <img src={logo} alt="Logo" width={150} height={40} loading="lazy" />
          </Link>

          {/* Desktop Navigation Links */}
          <nav className="hidden md:flex">
            <ul className="flex gap-x-6 text-richblack-25 font-semibold">
              {NavbarLinks.map((link, index) => (
                <li key={index}>
                  {/* Catalog Dropdown */}
                  {link.title === "Catalog" ? (
                    <div className={`group relative flex cursor-pointer items-center gap-1 ${matchRoute("/catalog/:catalogName") ? "text-blue-50" : "text-richblack-25"}`}>
                      <p>{link.title}</p>
                      <BsChevronDown />
                      <div className="invisible absolute left-1/2 top-full z-10 w-[200px] transform -translate-x-1/2 mt-2 p-4 bg-richblack-5 text-richblack-900 font-semibold rounded-lg opacity-0 transition-all duration-150 group-hover:visible group-hover:opacity-100 lg:w-[300px]">
                        <div className="absolute left-1/2 top-0 h-6 w-6 bg-richblack-5 transform -translate-x-1/2 -translate-y-1/2 rotate-45"></div>
                        {loading ? (
                          <p className="text-center">Loading...</p>
                        ) : subLinks.length ? (
                          subLinks.map((subLink, i) => (
                            <Link to={`/catalog/${subLink.name.split(" ").join("-").toLowerCase()}`} className="block px-4 py-2 hover:bg-blue-50 rounded-lg" key={i}>
                              <p>{subLink.name}</p>
                            </Link>
                          ))
                        ) : (
                          <p className="text-center">No Courses Found</p>
                        )}
                      </div>
                    </div>
                  ) : link.title === "Notes" ? (  // Add Notes Dropdown
                    <div className={`group relative flex cursor-pointer items-center gap-1 ${matchRoute("/notes/:noteName") ? "text-blue-50" : "text-richblack-25"}`}>
                      <p>{link.title}</p>
                      <BsChevronDown />
                      <div className="invisible absolute left-1/2 top-full z-10 w-[200px] transform -translate-x-1/2 mt-2 p-4 bg-richblack-5 text-richblack-900 font-semibold rounded-lg opacity-0 transition-all duration-150 group-hover:visible group-hover:opacity-100 lg:w-[300px]">
                        <div className="absolute left-1/2 top-0 h-6 w-6 bg-richblack-5 transform -translate-x-1/2 -translate-y-1/2 rotate-45"></div>
                        {loading ? (
                          <p className="text-center">Loading...</p>
                        ) : notesLinks.length ? (
                          notesLinks.map((note, i) => (
                            <Link to={`/notes/${note.name.split(" ").join("-").toLowerCase()}`} className="block px-4 py-2 hover:bg-blue-50 rounded-lg" key={i}>
                              <p>{note.name}</p>
                            </Link>
                          ))
                        ) : (
                          <p className="text-center">No Notes Available</p>
                        )}
                      </div>
                    </div>
                  ) : (
                    <Link to={link?.path}>
                      <p className={`${matchRoute(link?.path) ? "text-blue-50" : "text-richblack-25"}`}>{link.title}</p>
                    </Link>
                  )}
                </li>
              ))}
              {/* Search Form */}
              <form onSubmit={handelSearch} className='flex items-center relative lg:mx-16'>
                <input value={searchValue} onChange={(e) => { setSearchValue(e.target.value) }} id='searchinput' type="text" placeholder="Search Courses" className='absolute top-0 left-0 border-0 focus:ring-1 ring-richblack-400 rounded-full px-2 py-1 text-[15px] w-36 text-richblack-600 focus:outline-none focus:border-transparent bg-white' />
                <HiSearch type='submit' id='searchicon' size={20} className="text-richblack-400 top-2 absolute cursor-pointer left-28" />
              </form>
            </ul>
          </nav>

          {/* User Controls */}
          <div className="hidden md:flex items-center gap-x-4">
            {user && user?.accountType !== ACCOUNT_TYPE.INSTRUCTOR && user?.accountType !== ACCOUNT_TYPE.ADMIN && (
              <Link to="/dashboard/cart" className="relative">
                <AiOutlineShoppingCart className="text-2xl text-richblack-100" />
                {totalItems > 0 && (
                  <span className="absolute -bottom-2 -right-2 grid h-5 w-5 place-items-center rounded-full bg-richblack-600 text-xs font-bold text-yellow-100">
                    {totalItems}
                  </span>
                )}
              </Link>
            )}
            {token === null ? (
              <>
                <Link to="/login">
                  <button className="rounded-lg border border-richblack-900 bg-pure-greys-100 px-3 py-2 text-richblack-600 hover:bg-blue-200">Log in</button>
                </Link>
                <Link to="/signup">
                  <button className="rounded-lg border border-richblack-900 bg-pure-greys-100 px-3 py-2 text-richblack-600 hover:bg-blue-200">Sign up</button>
                </Link>
              </>
            ) : (
              <ProfileDropdown />
            )}
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden" onClick={toggleMenu}>
            {isMenuOpen ? <div /> : <AiOutlineMenu fontSize={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div  className={`fixed w-full top-0 z-40 bg-pure-greys-900 bg-opacity-75 transform ${isMenuOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 md:hidden`}>
        <div onClick={toggleMenu} className="flex flex-col items-start p-4 space-y-4">
          <button className="self-end" onClick={toggleMenu}>
            <AiOutlineClose fontSize={24} />
          </button>
          {NavbarLinks.map((link, index) => (
            <div key={index} className="w-[200px]">
              {link.title === "Catalog" ? (
                <div className="group relative">
                  <div className="flex items-center justify-between cursor-pointer text-white hover:text-blue-50" onClick={toggleMenu}>
                    <span>{link.title}</span>
                    <BsChevronDown />
                  </div>
                  <div className="rounded-xl mt-1 ml-2 pl-2 border border-pure-greys-100 bg-richblack-5 text-richblack-900">
                    {loading ? (
                      <p className="text-white">Loading...</p>
                    ) : subLinks.length ? (
                      subLinks.map((subLink, i) => (
                        <Link to={`/catalog/${subLink.name.split(" ").join("-").toLowerCase()}`} className="block px-4 py-[0.5px] text-richblack-900 hover:text-blue-50 " key={i} onClick={() => setIsMenuOpen(false)}>
                          {subLink.name}
                        </Link>
                      ))
                    ) : (
                      <p className="text-white">No Courses Found</p>
                    )}
                  </div>
                </div>
              ) : link.title === "Notes" ? (  // Add Notes Dropdown to Mobile Menu
                <div className="group relative">
                  <div className="flex items-center justify-between cursor-pointer text-white hover:text-blue-50" onClick={toggleMenu}>
                    <span>{link.title}</span>
                    <BsChevronDown />
                  </div>
                  <div className="rounded-xl mt-1 ml-2 pl-2 border border-pure-greys-100 bg-richblack-5 text-richblack-900">
                    {loading ? (
                      <p className="text-white">Loading...</p>
                    ) : notesLinks.length ? (
                      notesLinks.map((note, i) => (
                        <Link to={`/notes/${note.name.split(" ").join("-").toLowerCase()}`} className="block px-4 py-[0.5px] text-richblack-900 hover:text-blue-50 " key={i} onClick={() => setIsMenuOpen(false)}>
                          {note.name}
                        </Link>
                      ))
                    ) : (
                      <p className="text-white">No Notes Available</p>
                    )}
                  </div>
                </div>
              ) : (
                <Link to={link.path} className="text-white hover:text-gray-400" onClick={() => setIsMenuOpen(false)}>
                  {link.title}
                </Link>
              )}
            </div>
          ))}
        </div>
     {/* <div className="flex flex-col space-y-4 mt-4 w-full">
     {token === null ? (
              <>
               <div className="space-x-4 flex flex-row">
                <Link to="/login">
                  <button className=" mb-2 rounded-lg border border-richblack-900 bg-pure-greys-100 px-3 py-2 text-richblack-600 hover:bg-blue-200">Log in</button>
                </Link>
                <Link to="/signup">
                  <button className="rounded-lg border border-richblack-900 bg-pure-greys-100 px-3 py-2 text-richblack-600 hover:bg-blue-200">Sign up</button>
                </Link>
                  <form onSubmit={handelSearch} className='flex items-center relative '>
                            <input value={searchValue} onChange={(e) => { setSearchValue(e.target.value) }} id='searchinput' type="text" placeholder="Search" className=' absolute top-0 left-0 border-0 focus:ring-1 ring-richblack-400 rounded-full px-2 py-2 text-[15px] w-28 text-richblack-600 focus:outline-none focus:border-transparent bg-white' />
                            <HiSearch type='submit' id='searchicon' size={20} className="  text-richblack-600 top-2 absolute cursor-pointer left-20" />
                        </form>
                </div>
              </>
            ) : (
              <ProfileDropdown />
            )}
     </div> */}


<div className="flex flex-col space-y-2 mt-2 w-full ml-2 mb-2">
            {user && user?.accountType !== ACCOUNT_TYPE.INSTRUCTOR && user?.accountType !== ACCOUNT_TYPE.ADMIN && (
              <Link to="/dashboard/cart" className="relative">
                <AiOutlineShoppingCart className="text-2xl text-white" />
                {totalItems > 0 && (
                  <span className=" -bottom-2 -right-2 grid h-5 w-5 place-items-center rounded-full bg-richblack-600 text-xs font-bold text-yellow-100">
                    {totalItems}
                  </span>
                )}
              </Link>
            )}
            {token === null ? (
              <>
               <div className="space-x-4 flex flex-row">
                <Link to="/login">
                  <button className=" rounded-lg border border-richblack-900 bg-pure-greys-100 px-3 py-2 text-richblack-600 hover:bg-blue-200">Log in</button>
                </Link>
                <Link to="/signup">
                  <button className="rounded-lg border border-richblack-900 bg-pure-greys-100 px-3 py-2 text-richblack-600 hover:bg-blue-200">Sign up</button>
                </Link>
                  <form onSubmit={handelSearch} className='flex items-center relative '>
                            <input value={searchValue} onChange={(e) => { setSearchValue(e.target.value) }} id='searchinput' type="text" placeholder="Search Courses" className=' absolute top-0 left-0 border-0 focus:ring-1 ring-richblack-400 rounded-full px-2 py-2 text-[15px] w-36 text-richblack-600 focus:outline-none focus:border-transparent bg-white' />
                            <HiSearch type='submit' id='searchicon' size={20} className="  text-richblack-600 top-3 absolute cursor-pointer left-28" />
                        </form>
                </div>
              </>
            ) : (
             <>
               <form onSubmit={handelSearch} className='flex absolute ml-20'>
                            <input value={searchValue} onChange={(e) => { setSearchValue(e.target.value) }} id='searchinput' type="text" placeholder="Search Courses" className=' absolute top-0 left-0 border-0 focus:ring-1 ring-richblack-400 rounded-full px-2 py-2 text-[15px] w-36 text-richblack-600 focus:outline-none focus:border-transparent bg-white' />
                            <HiSearch type='submit' id='searchicon' size={20} className="  text-richblack-600 top-3 absolute cursor-pointer left-28" />
                        </form>
                        
               <ProfileDropdown />
              
              </>
            )}
          </div>
      </div>
    </div>
  );
}

export default Navbar;



